import { styled } from '@mui/material';
import { PropsWithChildren } from 'react';

import { Typography } from '../../Typography';

const StyledTitle = styled(Typography)({
  fontWeight: 700,
  fontSize: 24,
  lineHeight: '29px',
  letterSpacing: 'normal',
});

export const Title = ({ children }: PropsWithChildren) => {
  return (
    <StyledTitle component="h1" variant="header">
      {children}
    </StyledTitle>
  );
};
